var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProbabilityOfSnowVisibility01 = function SvgProbabilityOfSnowVisibility01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12.9,
    y1: 159.77,
    x2: 160.85,
    y2: 18.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 12.9,
    y1: 159.77,
    x2: 160.85,
    y2: 18.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 49.42,
    y1: 197.94,
    x2: 197.37,
    y2: 56.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 62.78,
    y1: 211.9,
    x2: 210.73,
    y2: 70.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 80.82,
    y1: 230.76,
    x2: 228.77,
    y2: 89.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 78.52,
    y1: 228.35,
    x2: 226.47,
    y2: 86.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 37.11,
    y1: 185.08,
    x2: 185.07,
    y2: 43.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 44.6,
    y1: 192.9,
    x2: 192.55,
    y2: 51.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 23.62,
    y1: 170.97,
    x2: 171.57,
    y2: 29.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 15.31,
    y1: 162.29,
    x2: 163.26,
    y2: 20.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 65.53,
    y1: 214.78,
    x2: 213.49,
    y2: 73.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -17.18,
    y1: 128.33,
    x2: 130.77,
    y2: -13.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 8.24,
    y1: 154.9,
    x2: 156.19,
    y2: 13.35,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M146.95,73.8l-31.19-17.46c-9.85-5.52-21.64-5.52-31.49,0l-31.19,17.46c-.97.55-1.55,1.55-1.55,2.64s.61,2.12,1.55,2.64l31.19,17.46c4.94,2.76,10.34,4.15,15.73,4.15s10.82-1.36,15.73-4.15l31.19-17.46c.97-.55,1.55-1.55,1.55-2.64s-.61-2.12-1.55-2.64h.03ZM100,94.63c-10.03,0-18.19-8.15-18.19-18.19s8.15-18.19,18.19-18.19,18.19,8.15,18.19,18.19-8.15,18.19-18.19,18.19M77.69,66.95c-1.24,2.91-1.94,6.12-1.94,9.49s.76,6.61,2.03,9.55l-17.03-9.55,16.94-9.49ZM122.22,85.99c1.27-2.94,2.03-6.15,2.03-9.55s-.7-6.58-1.94-9.49l16.94,9.49-17.03,9.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,67.35c-5,0-9.09,4.09-9.09,9.09s4.09,9.09,9.09,9.09,9.09-4.09,9.09-9.09-4.09-9.09-9.09-9.09M100,79.47c-1.67,0-3.03-1.36-3.03-3.03s1.36-3.03,3.03-3.03,3.03,1.36,3.03,3.03-1.36,3.03-3.03,3.03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.45,119.38c-.59-1.02-1.89-1.37-2.9-.78l-5.91,3.41,1.24-4.62c.3-1.13-.37-2.3-1.5-2.6-1.14-.29-2.3.37-2.6,1.5l-2.34,8.73-4.55,2.63c-1.16-1.21-2.65-2.08-4.33-2.5v-5.17l6.39-6.39c.83-.83.83-2.18,0-3.01s-2.18-.83-3.01,0l-3.38,3.38v-6.91c0-1.17-.95-2.13-2.13-2.13s-2.13.95-2.13,2.13v6.9l-3.38-3.38c-.83-.83-2.18-.83-3.01,0-.83.83-.83,2.18,0,3.01l6.39,6.39v5.17c-1.68.41-3.17,1.29-4.34,2.5l-4.47-2.58-2.34-8.73c-.3-1.13-1.47-1.8-2.61-1.5-1.13.3-1.81,1.47-1.5,2.6l1.24,4.62-5.99-3.46c-1.01-.59-2.32-.24-2.9.78-.59,1.02-.24,2.32.78,2.9l5.98,3.45-4.62,1.24c-1.13.3-1.81,1.47-1.5,2.6.26.95,1.11,1.58,2.05,1.58.18,0,.37-.02.55-.07l8.73-2.34,4.5,2.6c-.23.8-.4,1.63-.4,2.5s.16,1.69.39,2.49l-4.48,2.59-8.73-2.34c-1.14-.29-2.3.37-2.6,1.5-.3,1.13.37,2.3,1.5,2.6l4.62,1.24-5.99,3.46c-1.02.59-1.36,1.89-.78,2.9.59,1.02,1.89,1.36,2.9.78l5.98-3.45-1.24,4.62c-.3,1.14.37,2.3,1.5,2.61,1.16.3,2.31-.39,2.6-1.5l2.34-8.73,4.47-2.58c1.16,1.21,2.66,2.09,4.34,2.5v5.24l-6.39,6.39c-.83.83-.83,2.18,0,3.01.83.83,2.18.83,3.01,0l3.38-3.38v6.84c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-6.82l3.38,3.38c.83.83,2.18.83,3.01,0,.83-.83.83-2.18,0-3.01l-6.39-6.39v-5.26c1.68-.41,3.18-1.29,4.34-2.5l4.53,2.62,2.34,8.73c.3,1.11,1.44,1.81,2.61,1.5,1.13-.3,1.81-1.47,1.5-2.6l-1.24-4.62,5.92,3.42c1.01.59,2.32.24,2.9-.78.59-1.02.24-2.32-.78-2.9l-5.91-3.41,4.62-1.24c1.13-.3,1.81-1.47,1.5-2.6-.3-1.13-1.47-1.8-2.61-1.5l-8.73,2.34-4.56-2.63c.23-.79.39-1.62.39-2.49s-.16-1.7-.4-2.5l4.55-2.63,8.73,2.34c.19.05.37.07.55.07.94,0,1.8-.63,2.05-1.58.3-1.13-.37-2.3-1.5-2.6l-4.62-1.24,5.92-3.42c1.02-.59,1.36-1.89.78-2.9M116.41,138.55c-2.59,0-4.7-2.11-4.7-4.71s2.11-4.72,4.7-4.72,4.72,2.12,4.72,4.72-2.12,4.71-4.72,4.71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M153.38,119.3c-1.17,0-2.13.95-2.13,2.13v7.57c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M160.44,148.66c-1.17,0-2.13.95-2.13,2.13v7.57c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M135.71,167.72c-1.17,0-2.13.95-2.13,2.13v7.57c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M75.79,142.16c-1.17,0-2.13.95-2.13,2.13v7.57c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M55.95,176.12c-1.17,0-2.13.95-2.13,2.13v7.57c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M39.91,149.47c-1.17,0-2.13.95-2.13,2.13v7.57c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.1,138.42c1.34,0,2.42-1.08,2.42-2.42v-8.48l8.49,4.9c1.15.67,2.64.27,3.3-.88.67-1.16.27-2.63-.88-3.3l-8.49-4.9,7.34-4.24c1.16-.67,1.55-2.15.88-3.3-.67-1.16-2.15-1.55-3.3-.89l-7.34,4.24v-9.8c0-1.34-1.08-2.42-2.42-2.42s-2.42,1.08-2.42,2.42v9.8l-7.34-4.24c-1.15-.67-2.63-.27-3.3.89-.67,1.16-.27,2.63.88,3.3l7.34,4.24-8.49,4.9c-1.16.67-1.55,2.15-.88,3.3.67,1.16,2.15,1.55,3.3.88l8.49-4.9v8.48c0,1.34,1.08,2.42,2.42,2.42Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M95.83,200c1.34,0,2.42-1.08,2.42-2.42v-8.48l8.49,4.9c1.15.67,2.64.27,3.3-.88.67-1.16.27-2.63-.88-3.3l-8.49-4.9,7.34-4.24c1.16-.67,1.55-2.15.88-3.3-.67-1.16-2.15-1.55-3.3-.89l-7.34,4.24v-9.8c0-1.34-1.08-2.42-2.42-2.42s-2.42,1.08-2.42,2.42v9.8l-7.34-4.24c-1.15-.67-2.63-.27-3.3.89-.67,1.16-.27,2.63.88,3.3l7.34,4.24-8.49,4.9c-1.16.67-1.55,2.15-.88,3.3.67,1.16,2.15,1.55,3.3.88l8.49-4.9v8.48c0,1.34,1.08,2.42,2.42,2.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.65,91.9h-5.92c-12.63,0-22.91-10.28-22.91-22.91s10.28-22.91,22.91-22.91c1.87,0,3.82.3,6.13.95,3.04.92,5.86,2.56,7.94,4.63.62.62,1.43.92,2.24.92s1.63-.31,2.25-.94c1.24-1.24,1.23-3.25-.01-4.49-2.82-2.8-6.58-5.01-10.61-6.22-.01,0-.02,0-.03,0,0,0-.01-.01-.02-.01-2.91-.82-5.41-1.2-7.88-1.2-16.13,0-29.26,13.13-29.26,29.26s13.13,29.26,29.26,29.26h5.92v-6.35Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.76,24.72c-2.75,0-5.56.37-8.53,1.13C128.98,10.05,113.48,0,95.98,0,76.6,0,59.6,12.41,53.69,30.87c-.54,1.67.38,3.46,2.05,3.99,1.68.54,3.46-.38,3.99-2.06,5.07-15.82,19.63-26.45,36.24-26.45,14.76,0,27.86,8.36,34.19,21.55-4.36,1.99-7.37,4.93-9.22,7.28-1.08,1.38-.85,3.37.53,4.46.58.46,1.27.68,1.96.68.94,0,1.87-.42,2.5-1.21,1.72-2.18,4.73-5.06,9.34-6.38.02,0,.09-.02.11-.03,3.38-1.1,6.45-1.64,9.37-1.64,16.77,0,30.42,13.65,30.42,30.42s-13.05,29.8-29.31,30.39v6.35c19.76-.59,35.66-16.83,35.66-36.74s-16.49-36.77-36.76-36.77"
  })));
};
export default SvgProbabilityOfSnowVisibility01;